import useSidebarStatus from '@/hooks/useSidebarStatus';
import SidebarComponent, { CustomSidebarOptionType } from './Sidebar.component';

type SidebarType = {
  sidebarOptions: CustomSidebarOptionType[];
};

const Sidebar = function ({ sidebarOptions }: SidebarType): JSX.Element {
  const sidebarStatus = useSidebarStatus();

  return (
    <SidebarComponent
      toggleMenu={sidebarStatus.toggleSidebarStatus}
      isOpen={sidebarStatus.isSidebarOpen}
      options={sidebarOptions}
    />
  );
};

export default Sidebar;
